<template v-if="!pageLoader.loading.value">
    <div class="row dashboard__table-row">
        <div class="col-md-12 overflow-x">
            <div v-if="allowedCheckbox" class="c-table-checkbox">
                <div class="checkbox">
                    <label>
                        <input type="checkbox" @change="(e) => pickAll(e)" />
                        <i :style="!isPicked ? 'background: white' : ''"></i>
                    </label>
                </div>
            </div>
            <table
                class="dashboard__table"
                role="grid"
                :style="
                    allowedCheckbox ? 'border-spacing: 0 4px;' : 'border-spacing: 0 8px;'
                "
            >
                <colgroup>
                    <col width="4%" />
                    <col width="1%" />
                    <col width="25%" />
                    <col width="1%" />
                    <col width="10%" />
                    <col width="3%" />
                </colgroup>
                <thead class="dashboard__table-header" role="rowgroup">
                    <tr role="row">
                        <th class="dashboard__table-th text-left" aria-sort="none">
                            <div class="dashboard__table-title">
                                <i18n-t keypath="myOrders.orderStatus" />
                            </div>
                        </th>
                        <th
                            class="dashboard__table-th dashboard__table-sorting text-left"
                            :class="sortingClass(orderTableColumns.Date)"
                            :aria-sort="sortAria"
                        >
                            <div
                                class="dashboard__table-title"
                                @click="changeCurrentSortType(orderTableColumns.Date)"
                                style="white-space: nowrap"
                            >
                                <i18n-t keypath="myOrders.orderDate" />
                            </div>
                        </th>

                        <th
                            class="
                                dashboard__table-th
                                dashboard__table-th--p
                                dashboard__table-sorting
                                text-left
                            "
                            :class="sortingClass(orderTableColumns.Reference)"
                            :aria-sort="sortAria"
                        >
                            <div
                                class="dashboard__table-title"
                                @click="
                                    changeCurrentSortType(orderTableColumns.Reference)
                                "
                            >
                                <i18n-t keypath="myOrders.orderDetails" />
                            </div>
                        </th>

                        <th
                            class="dashboard__table-th dashboard__table-sorting text-left"
                            :class="sortingClass(orderTableColumns.CarsAmount)"
                            :aria-sort="sortAria"
                        >
                            <div
                                class="dashboard__table-title"
                                @click="
                                    changeCurrentSortType(orderTableColumns.CarsAmount)
                                "
                            >
                                <i18n-t keypath="cart.vehicles" />
                            </div>
                        </th>

                        <th
                            class="dashboard__table-th dashboard__table-sorting text-left"
                            :class="sortingClass(orderTableColumns.Price)"
                            :aria-sort="sortAria"
                        >
                            <div
                                class="dashboard__table-title"
                                @click="changeCurrentSortType(orderTableColumns.Price)"
                            >
                                <i18n-t keypath="cart.orderAmount" />
                            </div>
                        </th>

                        <th
                            class="dashboard__table-th dashboard__table-th--p text-left"
                            aria-sort="none"
                        >
                            <div class="dashboard__table-title">
                                <i18n-t keypath="myOrders.actions" />
                            </div>
                        </th>
                    </tr>
                </thead>

                <tbody class="dashboard__table-body">
                    <template v-if="!isLoading">
                        <order-table-item
                            v-for="_order of orders"
                            :key="_order.id"
                            :order="_order"
                            :orderStatus="currentStatus"
                            v-model:_selectedOrders="selectedOrders"
                            v-model:_declineOrderIds="declineOrderIds"
                            v-model:_approveOrders="approveOrders"
                            v-model:_updateData="updateData"
                            v-model:_orderPaymentDto="orderPaymentDto"
                            v-model:_orderId="orderId"
                            v-model:_isPaymentsTransactionsPopup="
                                isPaymentsTransactionsPopup
                            "
                            v-model:_viewProformaOrder="viewProformaOrder"
                        />
                    </template>
                    <div v-else class="c-spin--">
                        <p-spinner strokeWidth="8" animationDuration=".8s" />
                    </div>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script lang="ts">
import { OrdersTable } from "@/dashboard/my-orders/orders-table/orders-table";

export default OrdersTable;
</script>
